import React, { useEffect, useState } from "react";
import Modal from "../Common/Modal";

type Props = {
    isLoggedIn: boolean;
    googleClientId: string;
};

const GoogleOneTap = ({ isLoggedIn, googleClientId }: Props) => {
    const [errorMessage, setErrorMessage] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    // モーダルの開閉を切り替える関数
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    useEffect(() => {
        // ログイン済み、またはクライアントIDがない場合は処理しない
        if (isLoggedIn || !googleClientId || !window.google?.accounts?.id) {
            return;
        }

        // Google One Tap を初期化
        window.google.accounts.id.initialize({
            client_id: googleClientId,
            callback: handleCredentialResponse,
            cancel_on_tap_outside: false,
        });

        // One Tap の表示を開始
        window.google.accounts.id.prompt();
    }, [isLoggedIn, googleClientId]);

    // One Tap の認証コールバック処理
    const handleCredentialResponse = (response: any) => {
        fetch("/api/accounts/google_login", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                credential: response.credential,
            }),
        })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) throw data;

                // 認証成功時はページをリロード
                if (data.status === "ok") {
                    window.location.reload();
                }
            })
            .catch((error) => {
                // エラー時はモーダルで通知
                setErrorMessage(error.message || "Googleログインに失敗しました");
                setIsModalOpen(true);
            });
    };

    return (
        <>
            {/* ログイン失敗時にエラーメッセージを表示 */}
            <Modal isActive={isModalOpen} toggleModal={toggleModal}>
                <div className="text-center text-sm whitespace-pre-line">{errorMessage}</div>
            </Modal>
        </>
    );
};

export default GoogleOneTap;
